import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check, X } from 'lucide-react';
export function WhoIsFor() {
  const isFor = ['Mujeres latinas de 45 a 65 años residentes en EE.UU.', "Quienes sienten que la menopausia o pre-menopausia 'secuestró' su cuerpo.", 'Mujeres que sufren de inflamación abdominal constante (hinchazón).', 'Madres y profesionales con poco tiempo que necesitan soluciones prácticas.'];
  const notFor = ["Personas que buscan una 'pastilla mágica' sin cambiar un solo hábito.", 'Atletas de alto rendimiento con necesidades competitivas.', 'Quienes no están dispuestos a dedicar 15 minutos a planificar su día.'];
  return <section className="py-20 bg-white" data-id="element-204">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-205">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-206">
          {/* Para quién es */}
          <FadeIn data-id="element-207">
            <div className="bg-[#E8F0E8] p-8 md:p-10 rounded-3xl h-full border border-[#1A5C4C]/10" data-id="element-208">
              <h3 className="text-2xl font-serif text-[#1A5C4C] mb-8 text-center" data-id="element-209">
                Este programa ES para ti si:
              </h3>
              <ul className="space-y-6" data-id="element-210">
                {isFor.map((item, idx) => <li key={idx} className="flex items-start space-x-4" data-id="element-211">
                    <div className="bg-[#1A5C4C] rounded-full p-1 mt-1 flex-shrink-0" data-id="element-212">
                      <Check className="w-4 h-4 text-white" data-id="element-213" />
                    </div>
                    <span className="text-[#2A2A2A]" data-id="element-214">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Para quién NO es */}
          <FadeIn delay={0.2} data-id="element-215">
            <div className="bg-gray-50 p-8 md:p-10 rounded-3xl h-full border border-gray-200" data-id="element-216">
              <h3 className="text-2xl font-serif text-gray-600 mb-8 text-center" data-id="element-217">
                Este programa NO es para ti si:
              </h3>
              <ul className="space-y-6" data-id="element-218">
                {notFor.map((item, idx) => <li key={idx} className="flex items-start space-x-4" data-id="element-219">
                    <div className="bg-gray-300 rounded-full p-1 mt-1 flex-shrink-0" data-id="element-220">
                      <X className="w-4 h-4 text-gray-600" data-id="element-221" />
                    </div>
                    <span className="text-gray-600" data-id="element-222">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}